<div class="reconnecting-overlay {{ colorMode }}">
  <div class="message-container">
    <img class="bounce" src="../../../../assets/icon_sad_dark.svg" />
    <div class="message">
      <div class="text">
        {{ 'Oops! We lost connection to the room. Attempting to reconnect...' | translate }}
      </div>
      <div class="actions">
        <andor-button (click)="odinService.disconnect()">
          <span>{{ 'Cancel' | translate }}</span>
        </andor-button>
      </div>
    </div>
  </div>
</div>
